import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const emptyParallel = () => {
    const dataFunc = {
        generator: async () => [],
        type: 0,
    };
    return new BasicParallelEnumerable(dataFunc);
};
